import { addDays, format } from 'date-fns';
import { useEffect, useState } from 'react';

export interface DateRange {
  start: Date;
  end: Date;
}

interface DateRangePickerProps {
  value?: DateRange;
  onChange?: (range: DateRange) => void;
}

export const createPresetRange = (days: number): DateRange => ({
  start: addDays(new Date(), -days),
  end: new Date(),
});

const DateRangePicker = ({ value, onChange }: DateRangePickerProps) => {
  const [range, setRange] = useState<DateRange>(value ?? createPresetRange(7));

  useEffect(() => {
    if (value) {
      setRange(value);
    }
  }, [value]);

  const handlePreset = (days: number) => {
    const next = createPresetRange(days);
    setRange(next);
    onChange?.(next);
  };

  return (
    <div className="flex items-center gap-2 text-xs text-slate-300">
      <span>{format(range.start, 'MMM d, yyyy')} → {format(range.end, 'MMM d, yyyy')}</span>
      <div className="flex gap-1">
        {[7, 30, 90].map((days) => (
          <button
            key={days}
            type="button"
            onClick={() => handlePreset(days)}
            className="rounded-md border border-slate-700 px-2 py-1 transition hover:border-slate-500 hover:text-white"
          >
            Last {days}d
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateRangePicker;
